<!-- =========================================================================================
  File Name: ECommerceItemDetail.vue
  Description: eCommerce Item Detail page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="item-detail-page">

    <vs-alert color="danger" title="Error Fetching Product Data" :active.sync="error_occured">
      <span>{{ error_msg }}. </span>
      <span>
        <span>Check </span><router-link :to="{name:'ecommerce-shop'}" class="text-inherit underline">All Items</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="item_data" :key="item_data.codart">


      <template slot="no-body">

        <div class="item-content">

          <!-- Item Main Info -->
          <div class="product-details p-6">
            <div class="vx-row mt-6">
              <div class="vx-col md:w-2/5 w-full flex items-center justify-center">
                <div class="product-img-container w-3/5 mx-auto mb-10 md:mb-0">
                  <img :src="item_data.imagen?('data:image/png;base64,'+item_data.imagen+''):defaultImageURL" :alt="item_data.nomart" class="responsive">
                </div>
              </div>

              <!-- Item Content -->
              <div class="vx-col md:w-3/5 w-full">

                <h3>{{ item_data.nomart }}</h3>

                <p class="my-2">
                  <span class="mr-2">POR</span>
                  <span>{{ item_data.brand }}</span>
                </p>
                <p class="flex items-center flex-wrap">
                  <span class="text-2xl leading-none font-medium text-primary mr-4 mt-2">${{ lispreShow () }}</span>
                </p>

                <vs-divider />

                <p>{{ item_data.codart }}</p>

                <vs-divider />

                <div class="vx-row">

                  <div class="vx-col w-full">
                    <p class="my-2">
                      <span>DISPONIBLE</span>
                      <span class="mx-2">-</span>
                      <span class="text-success">EN STOCK</span>
                    </p>
                  </div>

                  <div class="vx-col w-full">
                    <div class="flex flex-wrap items-start mb-4">

                      <!-- Add To Cart Button -->
                      <vs-button
                        class="mr-4 mb-4"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        v-if="!isInCart(item_data.objectID)"
                        @click="toggleItemInCart(item_data)">
                        AÑADIR AL CARRITO
                      </vs-button>

                      <vs-button
                        v-else
                        class="mr-4 mb-4"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        @click="$router.push({name: 'ecommerce-checkout'}).catch(err => {})">
                        VER EN CARRITO
                      </vs-button>

                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>


        </div>

      </template>
    </vx-card>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import algoliasearch from 'algoliasearch/lite'
import StarRating from 'vue-star-rating'
import axios from "axios";
import auth from '@/auth/authService'
import { mapState, mapActions } from 'vuex'

var token = auth.getToken()
var codemp = localStorage.getItem("codemp")
var lispre = localStorage.getItem("lispre");
var parametros = JSON.parse(localStorage.getItem("parcli"));

export default{
  components: {
    swiper,
    swiperSlide,
    StarRating
  },
  data () {
    return {
      defaultImageURL: require('@/assets/images/elements/not-available-es.png'),
      algolia_index: algoliasearch(
        'latency',
        '6be0576ff61c053d5f9a3225e2a90f76'
      ).initIndex('instant_search'),
      item_data: null,
      error_occured: false,
      error_msg: '',

      // Related Products Swiper
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 55,
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 55
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 55
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 55
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 55
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      // Below is data which is common in any item
      // Algolia's dataSet don't provide this kind of data. So, here's dummy data for demo
      available_item_colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
      opt_color: '#7367F0',
      is_hearted: false,

      related_items: [
      ]
    }
  },
  computed: {
    ...mapState('eCommerce',['lispreState', 'productState']),
    item_qty () {
      const item = this.$store.getters['eCommerce/getCartItem'](this.item_data.objectID)
      return Object.keys(item).length ? item.quantity : 1
    },
    itemColor () {
      return (obj) => {
        const style_obj = {}

        obj.style.forEach(p => { style_obj[p] = obj.color })

        return style_obj
      }
    },
    isInWishList () {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    },
    isInCart () {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    }
  },
  methods: {
    ...mapActions('eCommerce', ['getProducts']),
    products(codart, codemp){
      var payloadProducts = [];
      payloadProducts.codemp = codemp;
      payloadProducts.pagina = 0;
      payloadProducts.codcla = '';
      payloadProducts.search = codart;
      payloadProducts.maxpre = 1000000;
      payloadProducts.minpre = 0;
      payloadProducts.lispre = this.lispreState;
      payloadProducts.exis = parametros.ec_exiact;
      payloadProducts.itemspage = 1;
      payloadProducts.orden = parametros.ec_ordart || 'codart ASC';
      payloadProducts.token = auth.getToken();
      this.getProducts(payloadProducts).then(
      response => { 
        this.item_data = this.productState[0];
      })    
    },
    lispreShow (){
        var lis = this.lispreState;
        if(lis.toString() === '1'){
            return this.item_data.prec01
        }else if (lis.toString() === '2'){
            return this.item_data.prec02
        }else if(lis.toString() === '3'){
            return this.item_data.prec03
        }else if (lis.toString() === '4'){
            return this.item_data.prec04
        }else{
            return this.item_data.prec01
        }
    },
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    toggleItemInCart (item) {
      this.$store.dispatch('eCommerce/toggleItemInCart', item)
    },
    fetch_item_details (id) {
      this.algolia_index.getObject(id, (err, content) => {
        if (err) {
          this.error_occured = true
          this.error_msg = err.message
          console.error(err)
        } else {
          this.item_data = content
        }
      })

    },
  },
  created () {
    this.products(this.$route.params.item_id, codemp)
  }
}
</script>

<style lang="scss">

@import "@/assets/scss/vuexy/_variables.scss";

#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .item-features {
    background-color: #f7f7f7;

    .theme-dark & {
      background-color: $theme-dark-secondary-bg;
    }
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
      // padding-right: 2rem;
      // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0,0,0,0.1), 0 5px 12px 0 rgba(0,0,0,0.08) !important;

        .theme-dark & {
          background-color: $theme-light-dark-bg;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
</style>
